import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zipCode',
  standalone: false,
})
export class ZipCodePipe implements PipeTransform {
  transform(postalCode: string): string {
    return postalCode ? postalCode.slice(0, 3) + ' ' + postalCode.slice(3) : '';
  }
}
